const pad = (str: string | number) => (str + "").padStart(2, "0");
export const dataFormat = (date: Date) =>
  `${date.getFullYear().toString()}.${pad(date.getMonth() + 1)}.${pad(
    date.getDate()
  )}`;
